module.exports = __webpack_public_path__ + "img/logo_recent_old.d7e294b0.png";